import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import type { FC } from "react";
import PackageDay from "./PackageDay";
import type { PublicPackageResponse } from "./publicPackagesApi";

interface Props {
  readonly days: PublicPackageResponse["days"];
  readonly dayDetailsType: "DESCRIPTION" | "PLAN";
}

const PackageTimeline: FC<Props> = ({ days, dayDetailsType }) => (
  <Timeline position="right" data-testid="package-timeline">
    {days.map((d) => (
      <TimelineItem key={d.dayNumber} sx={{ "::before": { content: "none" } }}>
        <TimelineSeparator>
          <TimelineDot variant="outlined" />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <PackageDay day={d} dayDetailsType={dayDetailsType} />
        </TimelineContent>
      </TimelineItem>
    ))}
  </Timeline>
);

export default PackageTimeline;
